import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import C from "Constants";
// hooks
import { useBrandLosgisticIntegrations } from "hooks";
import { isOrderPaidByTableNumber } from "apiHelpers/api/ApiHelpers";
import usePaymentHelper from "features/payment-helpers/usePaymentHelper";
import usePlaceOrderHelper from "features/payment-helpers/usePlaceOrderHelper";
// components
import CheckoutPaymentMethod from "components/checkout/CheckoutPaymentMethodN";
import WithTransparentSpinner from "components/Hoc/WithTransparentSpinner";
import { SlideInFooter } from "components/layouts/SlideInLayout";
import ConditionalRenderer from "components/ConditionalRenderer";
import WalletPay from "helpers/payment_helpers/stripe/WalletPay";
import { RenderTotalPrice } from "components/DisplayPrice";
import { PlaceOrderButton } from "components/checkout";
import { PageHeaderV2 } from "components/PageHeader";
import WithLoading from "components/Hoc/WithLoading";
import { SavedCardsList } from "components/checkout";
import { CardWidgets } from "components/checkout";
// modules
import { useSuccesOrder, useDineIn } from "modules/dine-in/hooks";
import { UTILS } from "utils";
import { CartAction } from "store/actions";
import { errorNotification } from "utils/Utils";
import PayLaterTab from "../PayLaterTab";
import CheckoutModals from "../Modals";

const DineInPaymentHandler = ({isPreview=false}) => {
  const { goToLogin, goToSettings, goToHome, queryParam, goToPaymentComplete } = useDineIn();
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(null);
  const [resetSelectedType, setResetSelectedType] = useState(null);
  const redirectLink = {
    success: `dine-in/checkout?${queryParam}&payment=success`,
    failure: `dine-in/checkout?${queryParam}&payment=failure`,
  };
  const { dineInPaymentOptions, cart } = useSelector((state) => state.cart);
  const { currentPaymentMethod } = useSelector((state) => state.AppReducer);
  const { ordered } = useSelector((state) => state.order);

  let paymentOptions = {};
  if(dineInPaymentOptions){
    paymentOptions = dineInPaymentOptions;
  }

  const history = useHistory();
  const historyState = {
    ...(paymentOptions || {}),
    ...(history?.location?.state || {}),
  }
  const handleSuceessOrderRoute = useSuccesOrder();
  const { outlet_based_place_order } = usePlaceOrderHelper(
    handleSuceessOrderRoute
  );
  const { selectedStore /* selectedPayment */ } = useSelector(
    (state) => state.store
  );
  const { cartError, totalOrdersGrossAmount, split,  orderId, orderNumber, dineInTableNumber, dineInServiceFee } = useSelector((state) => state.cart);
  // const { selectedPaymentType } = useSelector(
  //   (state) => state.PaymentMethodReducer
  // );
  const { integrationsByName } = useBrandLosgisticIntegrations();
  const {
    placeOrder,
    captureCheckoutDotComPayment,
    setcardProcessing,
    cardProcessing,
    isLoading,
  } = usePaymentHelper(redirectLink, handleSuceessOrderRoute);

  if (
    ((!historyState?.paymentOptions?.id ||
    ![C.PAY_LATER, C.PAY_NOW].includes(
      historyState?.paymentOptions?.id
    )
  
  ) && !isPreview) || ((split ? split?.amount : totalOrdersGrossAmount)<=0)
  ) {
    goToHome();
  }

  const isPayLater =
    historyState?.paymentOptions?.id === C.PAY_LATER;

  useEffect(() => {
    if (cartError) {
      errorNotification(cartError, "top-center");
      setTimeout(() => {
        dispatch(CartAction.clearCartError());
      }, 3000); // Clear error after 3 seconds
    }
  }, [cartError, dispatch]);

  const validateOrderShipping = () => {
    const { errors, isValid, obj } = UTILS.validateOutletOrderObject();
    return {
      errors,
      isValid,
      obj,
    };
  };

  const checkIfOrderIsPaid = async () => {
    try {
      const response = await isOrderPaidByTableNumber({
        dineInTableNumber:dineInTableNumber,
        orderId:orderId,
        orderNumber:orderNumber,
      });
      if(response?.data?.isOrderAlreadyPaid) {
        goToPaymentComplete();
      }
    } catch (error) {
      console.log(error);
    }
    return false;
  }

  useEffect(() => {
    if(selectedOption) {
      checkIfOrderIsPaid();
    }
  },[selectedOption]);

  const renderFooter = () => {
    return selectedOption === C.WALLET.NEW_CARD &&
      [C.PAYBY, C.AFS_PAYMENT].includes(currentPaymentMethod) ? (
      <></>
    ) : (
      <SlideInFooter>
          <RenderTotalPrice total={split ? split?.amount : totalOrdersGrossAmount} />
        <PlaceOrderButton
          placeOrder={placeOrder}
          loading={cardProcessing}
          minOrder={0}
          isNewUI={true}
          text={history?.location?.state?.paymentOptions?.title}
        />
      </SlideInFooter>
    );
  };

  return (
    <WithLoading loading={isLoading}>
      <div className="checkout-page min-h-app-height store-page-popup">
        <PageHeaderV2
          pageTitle={
            selectedOption === C.WALLET.NEW_CARD ? "Add a card" : "Payment"
          }
          authClick={goToLogin}
          userClick={goToSettings}
          headerStyleProps={{
            className: "p-5",
            style: {
              // zIndex:cardProcessing || isLoading ? 0: 10,
              zIndex: 0,
            },
          }}
          onGoBack={
            selectedOption === C.WALLET.NEW_CARD
              ? () => setSelectedOption(null)
              : null
          }
        />
        <br />
        <br />
        <br />
        <div className="p-5 mt-3 flex flex-col gap-8">
          {/* Pay Later Tab */}
          <ConditionalRenderer condition={isPayLater}>
            <PayLaterTab
              key={C.PAY_LATER}
              optionSelected={historyState?.paymentOptions}
              paymentOptions={selectedStore?.dineInPaymentOptions}
            />
          </ConditionalRenderer>
          {/* Pay Now Tab */}
          <ConditionalRenderer
            condition={
              historyState?.paymentOptions?.id === C.PAY_NOW
            }
          >
            <CheckoutPaymentMethod
              key={C.PAY_NOW}
              paymentOptions={selectedStore?.dineInPaymentOptions}
              setSelectedOption={setSelectedOption}
              setcardProcessing={setcardProcessing}
              handleSuceessOrderRoute={handleSuceessOrderRoute}
              resetSelectedTypeProps={{
                selectedPaymentType: resetSelectedType,
                resetSelectedType: (type) => setResetSelectedType(null),
              }}
            >
              <SavedCardsList
                {...{
                  integrationsByName,
                  captureCheckoutDotComPayment,
                }}
              />
            </CheckoutPaymentMethod>
            <ConditionalRenderer
              condition={selectedOption && selectedOption === C.WALLET.NEW_CARD}
            >
              <CardWidgets
                isNewUI
                {...{
                  integrationsByName,
                  captureCheckoutDotComPayment,
                  redirectLink: redirectLink,
                  setcardProcessing: setcardProcessing,
                  handleSuceessOrderRoute: handleSuceessOrderRoute,
                }}
                className="m-0"
              />
            </ConditionalRenderer>
          </ConditionalRenderer>
          <CheckoutModals
            selectedPaymentType={selectedOption}
            resetState={(value) => {
              setResetSelectedType(value);
            }}
          />
        </div>
        {integrationsByName[C.STRIPE] ? (
          <WalletPay
            selectedStore={selectedStore}
            placeOrder={outlet_based_place_order}
            payUsingWallet={validateOrderShipping}
          >
            {renderFooter()}
          </WalletPay>
        ) : (
          renderFooter()
        )}
      </div>
      <WithTransparentSpinner loading={cardProcessing || isLoading} />
    </WithLoading>
  );
};

export default DineInPaymentHandler;
